import { getFirestore, query, collection, where, getDocs } from "firebase/firestore";

/**
 * Get a user
 * @returns User
 */
const getUserByEmail = async (email) => {
    const db = getFirestore();

    const q = query(collection(db, "users"), where("email", "==", email));

    const querySnapshot = await getDocs(q);

    let userToReturn;
    querySnapshot.forEach(el => {
        if (el.data()) userToReturn = el.data();
    })

    return userToReturn;
}

export {
    getUserByEmail,
}